import { render } from "./DashboardDrawer.vue?vue&type=template&id=3cc714bb"
import script from "./DashboardDrawer.vue?vue&type=script&lang=js"
export * from "./DashboardDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__